module.exports = __webpack_public_path__ + "static/home-3-1-d7c15d4bf9d13e4c0019cdd38771ed12.png";